// INTERFACES
import { AppData, FlowWorkspaceData } from "../interface/functionalityInterface";
import {
  AdvancedCalculatorUnitProps,
  CalculatorUnitProps,
  ConverterUnitProps,
  ReceiptUnitProps,
} from "../interface/propTypesInterface";

// COMPONENTS & FUNCTIONS
import { hydrateAdvancedCalculator } from "./advancedCalculatorHandler";

type StoredAppData =
  | AdvancedCalculatorUnitProps
  | CalculatorUnitProps
  | ConverterUnitProps
  | ReceiptUnitProps
  | FlowWorkspaceData;

export const getAppDataFromLocalStorage = (datatype: AppData[]) => {
  const appDataArr = JSON.parse(
    localStorage.getItem("appdata")!
  ) as StoredAppData[];
  if (appDataArr === null) {
    localStorage.setItem("appdata", JSON.stringify([]));
    return;
  }

  const hydratedAppData = appDataArr.map((data) => {
    const legacyRenderer = (data as unknown as { renderer?: string })
      .renderer;
    const isLegacyAdvancedCalculator =
      data.type === AppData.CALCULATOR &&
      legacyRenderer === "tank-emptying";

    if (
      data.type === AppData.ADVANCED_CALCULATOR ||
      isLegacyAdvancedCalculator
    ) {
      return hydrateAdvancedCalculator(data) ?? data;
    }
    return data;
  });

  return hydratedAppData.filter((data) =>
    datatype.some((type) => data.type === type)
  );
};

export const addAppDataToLocalStorage = (
  newData: StoredAppData
) => {
  const appDataArr = JSON.parse(
    localStorage.getItem("appdata")!
  ) as StoredAppData[];

  const newArr = appDataArr === null ? [newData] : [...appDataArr, newData];
  localStorage.setItem("appdata", JSON.stringify(newArr));
};

export const updateAppDataFromLocalStorage = (
  id: string,
  newData: StoredAppData
) => {
  const appDataArr = JSON.parse(
    localStorage.getItem("appdata")!
  ) as StoredAppData[];

  if (appDataArr === null) return;
  const newArr = appDataArr.map((data) => (data.id === id ? newData : data));
  localStorage.setItem("appdata", JSON.stringify(newArr));
};

export const removeAppDataFromLocalStorage = (id: string) => {
  const appDataArr = JSON.parse(
    localStorage.getItem("appdata")!
  ) as StoredAppData[];

  if (appDataArr === null) return;
  const newArr = appDataArr.filter((data) => data.id !== id);
  localStorage.setItem("appdata", JSON.stringify(newArr));
};

export const deleteAllOfTypeFromLocalStorage = (datatype: AppData[]) => {
  const appDataArr = JSON.parse(
    localStorage.getItem("appdata")!
  ) as StoredAppData[];
  if (appDataArr === null) return;

  const newArr = appDataArr.filter((data) =>
    datatype.every((type) => data.type !== type)
  );

  localStorage.setItem("appdata", JSON.stringify(newArr));
};

export const replaceAllAppDataInLocalStorage = (
  dataArr: StoredAppData[]
) => {
  localStorage.setItem("appdata", JSON.stringify(dataArr));
};
